import { highlightTree, tagHighlighter } from "@lezer/highlight";
import { Fragment, type ReactNode } from "react";
import { getLanguage, languageIdForName } from "./codeLanguages";
import { syntaxHighlightStyles } from "./syntaxHighlightStyles";

const highlighter = tagHighlighter(
  syntaxHighlightStyles.map(({ name, tag }) => ({
    tag,
    class: `tok-${name}`,
  }))
);

export function highlightCode(code: string, lang: string): ReactNode {
  const id = languageIdForName(lang);
  if (!id) return code;
  const tree = getLanguage(id).parser.parse(code);
  const nodes: ReactNode[] = [];
  let key = 0;
  let pos = 0;
  highlightTree(tree, highlighter, (from, to, classes) => {
    if (from > pos) {
      nodes.push(<Fragment key={key++}>{code.slice(pos, from)}</Fragment>);
    }
    nodes.push(
      <span className={classes} key={key++}>
        {code.slice(from, to)}
      </span>
    );
    pos = to;
  });
  if (pos < code.length) {
    nodes.push(<Fragment key={key}>{code.slice(pos)}</Fragment>);
  }
  return nodes;
}
